import {lazy} from 'react';

export const SectionWithEffectsLazy = lazy(() => import(/* webpackChunkName: "sectionWithEffects" */ '.'));
